var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'border-bottom': _vm.bottom},
              {'border-top': _vm.top},
              {'border-right': _vm.right},
              {'border-left': _vm.left}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }